import cn from 'classnames';
// Ui
import Text from 'ui3/Text/Text';
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './WizardStepIndicator.module.scss';

type WizardStepIndicatorProps = {
  steps: string[];
  currentStep: number;
};

const WizardStepIndicator = ({
  steps,
  currentStep,
}: WizardStepIndicatorProps): JSX.Element => (
  <div className={styles.root}>
    <div className={styles.steps}>
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isComplete = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;

        return (
          <div
            key={label}
            data-testid={`wizard-step-${stepNumber}`}
            className={cn(styles.step, {
              [styles.stepComplete]: isComplete,
            })}
          >
            <div
              className={cn(styles.circle, {
                [styles.circleComplete]: isComplete,
                [styles.circleActive]: isActive,
              })}
            >
              {isComplete ? (
                <MillionsIcon
                  name="check"
                  size={24}
                  aria-label={`Step ${stepNumber} complete`}
                />
              ) : (
                <Text
                  variant="body2Medium"
                  color={isActive ? 'background-dim' : 'lights-low'}
                >
                  {stepNumber}
                </Text>
              )}
            </div>
            <Text
              variant="body1Medium16"
              textAlign="center"
              className={cn(styles.label, {
                [styles.activeLabel]: isActive,
              })}
            >
              {label}
            </Text>
          </div>
        );
      })}
    </div>
  </div>
);

export default WizardStepIndicator;
